import pro from './pro'
import dev from './dev'
import testpro from './testpro'

let Config = {}

if (process.env.NODE_ENV === 'development') {
  Config = dev
} else if (process.env.NODE_ENV === 'production') {
  Config = pro
} else if (process.env.NODE_ENV === 'testbuild') {
  Config = testpro
}

export default Config



// WEBPACK FOOTER //
// ./src/config/index.js